<div class="trinka_cloud_wrap">

    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>引用チェック</h1>
                            <h2>Trinkaの引用チェックツールで
                                研究の論拠を強化</h2>
                                <p>Trinkaの引用チェックツール（Citation Checker）は、自動分析により論文を検証し、研究の前提や論証を弱める引用文献/参考文献を特定します。そして、より信頼性の高い文献の引用を可能にします。</p>
                            <div class="btn-group">
                                <a href="https://cloud.trinka.ai/signup?_rg=JP" class="filled-btn" target="_blank">今すぐチェックする</a>
                            </div>
                        </div>
                        <div class="top-banner-right">
                            <img src="../../../assets/images/Reference-Quality-Check.png" alt="引用チェッカー - 文法 チェック" class="img-fluid md50">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="howItWorks section-pd list-wrapper-style-2" #viewVideo>
        <div class="trinka_container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/citation-video.png" alt="引用ビデオ - 英文校正" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2">
                        <div class="trinka-title mb-0">
                            <h2>引用チェックツールの使い方</h2>
                            <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                            <p>Trinka引用チェックツールの使い方は簡単です。</p>
                            <p>ウォークスルービデオで、各種機能のご利用方法を説明しています。</p>
                            <p>ご不明点については、<a style="color: #0000ff;" (click)="scroll(target)" class="text-link">FAQ</a>も参考にしてください。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="cloud_key_features section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Trinka引用チェックツールの主な機能</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>Trinkaの引用チェックツールは、文献の品質リスクを下記の観点から識別し、引用文献/参考文献リストを改善し、研究の論拠を強化できる引用分析を行います。</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <img src="../../../assets/images/Retracted-References.png" alt="撤回された参考文献 - 文法 チェック">
                        <h3>撤回された論文</h3>
                        <p>出版後に撤回された研究論文を特定し、査読者に批判されないようにします。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <img src="../../../assets/images/Non-standard-References.png" alt="非標準 - 英文校正 ai">
                        <h3>権威付けのない論文</h3>
                        <p>査読なしの論文を排除し、引用の信頼性を向上させます。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <img src="../../../assets/images/low-visibility.png" alt="視認性が低い - 英文チ ェッカー">
                        <h3>注目度の低い論文</h3>
                        <p>被引用数の少ない引用文献/参考文献を特定し、論拠が弱まらないようにします。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <img src="../../../assets/images/Old-References.png" alt="古いリファレンス - 文法 チェック">
                        <h3>古い文献</h3>
                        <p>出版が古い論文を識別。重要性と妥当性の高い文献を引用できるようにします。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <img src="../../../assets/images/Overuse.png" alt="使いすぎ - 英文校正">
                        <h3>ジャーナルの偏り</h3>
                        <p>参考文献のジャーナルの偏りを特定。引用元を多様化して査読者の批判を回避します。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cloud_key_features section-pd list-wrapper-style-2" style="background-color: #f3eef6;">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Trinka引用チェックツールが選ばれる理由</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <div class="media gap-15">
                            <div class="media-left">
                                <img src="../../../../assets/images/languageScore_icon.svg" alt="無料の引用分析スコア - 文法 チェック" />
                            </div>
                            <div class="media-body">
                                <h3>無料の引用分析スコア</h3>
                                <p>引用分析スコアは無料でご覧いただけます。必要に応じて、有料のレポートもご利用いただけます。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <div class="media gap-15">
                            <div class="media-left">
                                <img src="../../../../assets/images/Up-to-date-Repository.png" alt="Crossrefの照会 - ai英文校正" />
                            </div>
                            <div class="media-body">
                                <h3>Crossrefの照会</h3>
                                <p>世界中の出版社や組織が信頼を置くCrossrefの広範な出版物レポジトリに照らしてすべての引用を検証します。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cloud_key_features section-pd">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>引用チェックツールレポートのサンプル</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>Trinka引用チェックツールの分析レポートのサンプルで、論文作成にどのようなメリットがあるのかをご確認ください。</p>
                    </div>
                </div>
                <div class="col-12">
                    <div class="viewSampleReportImg">
                        <a href="citation-checker/sample-report/">サンプルの全文を見る <i class="fa fa-arrows-alt" aria-hidden="true"></i></a>
                        <img src="../../../assets/images/citation-report.jpg" alt="引用 - 英文校正">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="trinka-banner section-pd-sm">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">さっそく無料の引用分析スコアを見てみませんか？</h3>
                    </div>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" class="white-btn" target="_blank">今すぐチェックする</a>
                    </div>
                </div>
            </div>  
        </div>
    </div>

    <div class="trinka-credits section-pd">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title mb-0 text-center">
                        <h2>引用チェックのレポート生成にはポイント（Credit）が必要です</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-10">
                    <div class="credit-section">
                        <div class="shape">
                            <svg xmlns="http://www.w3.org/2000/svg" width="745" height="140" viewBox="0 0 745 140" fill="none">
                                <path d="M210.74 99.3391C92.7255 118.025 21.074 68.6063 0 41.5614V169H721.602C749.822 122.013 775.522 23.2037 652.567 3.86251C498.872 -20.314 358.258 75.9822 210.74 99.3391Z" fill="#F5ECFF"/>
                            </svg>
                        </div>
                        <div class="media">
                            <div class="media-left">
                                <img src="../../../assets/images/new-credits.svg" alt="クレジット - 英文 チェック ai" />
                            </div>
                            <div class="media-body">
                                <h6>引用分析スコアの作成は無料で、ポイントをご利用いただくと詳細なレポートを生成することができます。1ポイントで、最大10件の引用を分析します。無料で付与されるポイントを使用するか、必要に応じてポイントをご購入ください。</h6>
                            </div>
                        </div>
                        <div class="image">
                            <img src="../../../assets/images/credits-banner.svg" alt="クレジット - 英文校正" />
                        </div>
                    </div>
                    <ul>
                        <li><span>*</span>
                            <p>
                                ご利用いただくTrinkaの機能に応じ、ポイントが消費されます。<br/>プレミアムプランをご利用の方には10ポイント、ベーシックプランをご利用の方には2ポイントが毎月無料で付与されます。詳しくは<a [routerLink]="['/features/credits']" class="text-link">こちら</a>をご覧ください。
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="faqQuestionAnwser section-pd pt-0" #target>
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-10">
                    <div class="trinka-title text-center">
                        <h2>よくあるご質問</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="faqQuestionsList">
                <div class="accordion" id="faq">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionOne">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                            Trinka引用チェックツールの使い方を教えてください</a>
                                    </div>
    
                                    <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                        <div class="card-body">
                                            <h4>3つの簡単なステップで引用の質を向上させます。</h4>
                                            <ol>
                                                <li>まずはTrinkaに<a href="https://cloud.trinka.ai/signup" target="_blank" class="text-link">無料で登録</a>してください</li>
                                                <li>左のナビゲーションパネルから「Citation Checker」のページに移動します</li>
                                                <li>文書をアップロードしてください。Google Drive、OneDrive、Dropbox、またはローカルフォルダからアップロードできます。すでにTrinkaにアップロードされている文書を使用することもできます。レポートは数分で生成されます</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionTwo">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                            aria-controls="QuestionTwoContent">
                                            Trinkaの引用チェックツールにはどこからアクセスできますか？</a>
                                    </div>
    
                                    <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                        <div class="card-body">
                                            <p>Trinka引用チェックツールは、現在Trinka Cloudプラットフォーム上で、すべてのユーザーの皆様にご利用いただけます。近日中にWordプラグインにも搭載される予定です。</p>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionThree">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                            aria-controls="QuestionThreeContent">
                                            Trinkaでは有料記事の引用もチェックできますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                        <div class="card-body">
                                            <p>はい。有料ジャーナルに掲載された参考文献に関しても、引用の品質チェックが可能です。</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionFour">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                            aria-controls="QuestionFourContent">
                                            引用レポートを共著者と共有することはできますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                        <div class="card-body">
                                            <!-- <p>In addition to all the features you get in Basic, you also get Power Mode with a Premium subscription.  Power Mode provides users with up to 40% more suggestions for their content while considering the context of the writing. Furthermore, </p> -->
                                            <p>現在のところ、レポートはお客様専用のTrinka Cloud上でのみ閲覧可能であり、共有いただくことはできません。将来的には可能になる予定です。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="otherApps section-pd-sm">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">もっとあります
                            Trinkaの
                            使い方</h3>
                    </div>
                    <ul>
                        <li>
                            <a [routerLink]="['/trinkacloud']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="cloud - 文法 チェック">
                                    <h3>Cloud</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/wordplugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word - 文法 チェック">
                                    <h3><span class="OpenSansFonts" style="font-weight: bold;">MS Word</span>
                                        <br /> プラグイン</h3>
                                </div>
                        </a>
                        </li>
                        <li>
                            <a [routerLink]="['/browser-plugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="../../../assets/images/other_Apps_browser.svg" alt="browser - 文法 チェック">
                                    <h3>ブラウザ
                                        <br />プラグイン</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/enterprise']">
                                <div class="app_name_content" style="padding: 0px;">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise - 文法 チェック">
                                    <h3 style="margin: 0 0 -2px 0;">Enterprise</h3>
                                    <span style="font-size: 12px; color: #000; position: relative;">(API, JS, & On-Premise)</span>
                                </div>
                            </a>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/XBuFdCM3xtk"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>